import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = (isSuccessful) =>
  makeStyles((theme: Theme) => {
    return createStyles({
      title: {
        textTransform: 'uppercase',
        color: isSuccessful ? colorsPalette.green : colorsPalette.white,
        lineHeight: 1.2,
        fontSize: 18,
        marginBottom: SMALL_MARGIN,
        textAlign: 'center',
        [theme.breakpoints.up('md')]: {
          fontSize: 28,
          textAlign: 'left',
        },
      },
    });
  });

export default useStyles;
